import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import aboutUs from '@/components/aboutUs'
import content from '@/components/content'
import news from '@/components/news'
import greenGuide from '@/components/greenGuide'
import supplierNameList from '@/components/supplierNameList'
import joinUs from '@/components/joinUs'
import contactUs from '@/components/contactUs'
import greenEnterpriseCase from '@/components/greenEnterpriseCase/greenEnterpriseCase'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs
    },
    // {
    //   path: '/content',
    //   name: 'content',
    //   component: content
    // },
    // 栏目内容
  {
    path: '/content',
    name: 'content',
    component: content,
    children: [{
      path: '/content/:typeName/:subTypeName',
      name: 'subContent',
      component: content,
    },
    {
      path: '/content/:typeName',
      name: 'subType',
      component: content,
    }
  ]
  },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/greenGuide',
      name: 'greenGuide',
      component: greenGuide
    },
    {
      path: '/supplierNameList',
      name: 'supplierNameList',
      component: supplierNameList,
      query: {name: 'mdType'}
    },
    {
      path: '/greenEnterpriseCase',
      name: 'greenEnterpriseCase',
      component: greenEnterpriseCase,
      query: {name: 'mdType'}
    },
    {
      path: '/joinUs',
      name: 'joinUs',
      component: joinUs
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      component: contactUs
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js